module.exports = __webpack_public_path__ + "static/antd-badge-ribbon-b55ac2224901ef7e8711eb368243585b.png";